import { gql } from '@apollo/client';

export const SAVE_FILTER_PRESET_MUTATION = gql`
  mutation SaveFilterPresetMutation(
    $id: ID
    $name: String!
    $filter: Filters!
  ) {
    saveFilterPreset(id: $id, name: $name, filter: $filter) {
      ... on SaveFilterPresetSuccess {
        preset {
          id
          name
          createdAt
          updatedAt
          filter {
            sites
            groups
            materials
            eras
            findTypes
            tags
            hasImages
            hasAmcrId
            createdByMe
            foundAt {
              preset
              from
              to
              timeZone
            }
          }
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
